import React from "react";
import { FocusScope } from "react-aria";
import { buildMakeMakeComercialUrlByEnv } from "../../../../util/host-utilities";

/**
 * Componente con las opciones Colegios, Bibliotecas y Familias
 * @param {Function} setOpenDropdown - actualiza el estado openDropdown
 * @param {boolean} openDropdown - estado que indica si se debe ver las opciones de planes
 * @param {object} textosInterfaz- contiene los textos de interfaz
 * @returns {JSX.Element} DropdownPlanes
 */
export const DropdownPlanes = ({ setOpenDropdown, openDropdown, textosInterfaz }) => {
  const schoolsUrl = buildMakeMakeComercialUrlByEnv({
    path: "/planes/colegios",
  });
  const librariesUrl = buildMakeMakeComercialUrlByEnv({
    path: "/planes/bibliotecas",
  });

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setOpenDropdown(false);
    }
  };

  return (
    openDropdown && (
      <FocusScope contain restoreFocus autoFocus>
        <ul onKeyDown={handleKeyDown}>
          <li className={`${openDropdown ? 'activeMode body-m' : 'inactiveMode'}`}>
            <a
              href={schoolsUrl}
              className="focusable-red"
              onClick={() => setOpenDropdown(false)}
            >{textosInterfaz?.colegios || 'Colegios'}</a>
          </li>
          <li className={`${openDropdown ? 'activeMode body-m' : 'inactiveMode'}`}>
            <a
              href={librariesUrl}
              className="focusable-red"
              onClick={() => setOpenDropdown(false)}
            >{textosInterfaz?.bibliotecas || 'Bibliotecas'}</a>
          </li>


          <li className={`close-options ${openDropdown ? 'activeMode body-m' : 'inactiveMode'}`}>
            <button onClick={() => setOpenDropdown(false)} aria-label={textosInterfaz?.button_close_list_alt || "Cerrar la lista desplegable"} className="w-100 focusable-red ">
              {textosInterfaz?.button_close_list || "Cerrar"}
            </button>
          </li>
        </ul>

      </FocusScope>
    )
  )
}
